const STORAGE_PREFIX = `${process.env.REACT_APP_STORAGE_PREFIX}:Horus`

export const SESSION_STORAGE_CHAVE_USER = `${STORAGE_PREFIX}:user`.toUpperCase()

export const SESSION_STORAGE_CHAVE_ROTA_POS_LOGIN =
  `${STORAGE_PREFIX}:rotaPosLogin`.toUpperCase()

export const LOCAL_STORAGE_CHAVE_PF =
  `${STORAGE_PREFIX}:ProductFruits:Hash`.toUpperCase()

export const LOCAL_STORAGE_CHAVE_PF_SURVEYS =
  `${STORAGE_PREFIX}:ProductFruits:Pesquisas`.toUpperCase()

export const POLITICA_DE_PRIVACIDADE_BASE_URL =
  'https://termos.digix.com.br/politicasDePrivacidade?produto='

export const TERMOS_DE_USO_BASE_URL =
  'https://termos.digix.com.br/termos/visualizacao?produto='

export const LOCAL_STORAGE_CHAVE_OCULTAR_AVISO_COMPRESSAO_EXTREMA =
  `${STORAGE_PREFIX}:Baixar:OcultarAvisoCompressaoExtrema`.toUpperCase()
